import styled, { css } from "styled-components";
import { Wrapper } from "AppReact";

const template = styled.div`
  ${({ displayState }) => css`
    display: ${displayState?.hidden ? 'none' : 'flex'};
    align-items: center;

    @media only screen and (min-width: 768px) {
      width: 33%;
      padding-right: 20px;
    }
  `}
`;

export default Wrapper(template);